import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.min.css';

const setupFundingSourcesFormset = function setupFundingSourcesFormset () {
    if ($('.funding-sources-formset').length > 0 ) {
        const $formset = $('.funding-sources-formset');
        $('.funding-sources-formset .formset-row').formset({
            prefix: $formset.data('prefix'),
            addText: `<i class="fas fa-fw fa-plus"></i> ${$formset.data('add-text') || 'Add funding source'}`,
            addCssClass: 'add-row btn btn-link btn-xs',
            deleteText: '<i class="fas fa-trash"></i>',
            deleteCssClass: 'delete-row btn btn-link btn-xs text-danger order-3 col-auto'
        });
    }
};

export default setupFundingSourcesFormset;
